// extracted by mini-css-extract-plugin
export default {"down-arrow":"CustomRangePicker_down-arrow__WwZkq","nextprev-icon":"CustomRangePicker_nextprev-icon__sBeUH"};